import { MainView } from "../../views/preview";

export default function Component(props) {
    return <MainView />;
}